export const progressRootClasses =
  'relative h-4 w-full overflow-hidden rounded-full bg-background-secondary';

export const progressIndicatorClasses =
  'size-full flex-1 bg-validation-success transition-all';
